import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Notification } from '../../../types/Notification';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

type ToggleReadPayload = Record<string, boolean>;

const toggleNotificationRead = async (reads: ToggleReadPayload) => {
  const response = await CustomAxios.patch(`notifications/toggle_read`, { reads });
  return response.data;
};

export function useToggleNotificationRead() {
  return useMutation({
    mutationFn: (reads: ToggleReadPayload) => toggleNotificationRead(reads),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allNotifications] });
    },
    onError: (err: AxiosError, reads, context: { previousNotifications?: Notification[] } | undefined) => {
      console.error('Notification update error:', err);
      if (context?.previousNotifications) {
        queryClient.setQueryData<Notification[]>([queryKeys.allNotifications], context.previousNotifications);
      }
    },
  });
}
